export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class SumupUnit {
  id: number
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.name = sumupGroup.name;
  }
}

export class SumupUnitExaminee {
  practice_examinee_id: number
  sheet_group_key: number
  student_no_character: string
  student_name: string
  addition: string
  gender: number
  score: number
  total_rank: number
  total_std_score: number
  gender_rank: number
  gender_std_score: number
  result_image_created: boolean
  isSelected: boolean = false
  base64Images: string[] = []
  isDownloaded: boolean = false
  rowObject: any = {}

  constructor(sumupUnitExaminee: any){
    this.practice_examinee_id = sumupUnitExaminee.practice_examinee_id;
    this.sheet_group_key = sumupUnitExaminee.sheet_group_key;
    this.student_no_character = sumupUnitExaminee.student_no_character;
    this.student_name = sumupUnitExaminee.student_name;
    this.addition = sumupUnitExaminee.addition;
    this.gender = sumupUnitExaminee.gender;
    this.score = sumupUnitExaminee.score;
    this.total_rank = sumupUnitExaminee.total_rank;
    this.total_std_score = sumupUnitExaminee.total_std_score.toFixed(1);
    this.gender_rank = sumupUnitExaminee.gender_rank;
    this.gender_std_score = sumupUnitExaminee.gender_std_score.toFixed(1);
    this.result_image_created = sumupUnitExaminee.result_image_created;
  }
}

export class SumupUnitAll {
  allot: number
  total_examinee_count: number
  total_avg_score: number
  total_score_rate: number
  total_min_score: number
  total_max_score: number
  man_examinee_count: number
  man_avg_score: number
  man_score_rate: number
  man_min_score: number
  man_max_score: number
  woman_examinee_count: number
  woman_avg_score: number
  woman_score_rate: number
  woman_min_score: number
  woman_max_score: number
 
  constructor(sumupUnitAll: any){
    this.allot = sumupUnitAll.allot;
    this.total_examinee_count = sumupUnitAll.total_examinee_count;
    this.total_avg_score = sumupUnitAll.total_avg_score.toFixed(1);
    this.total_score_rate = sumupUnitAll.total_score_rate.toFixed(1);
    this.total_min_score = sumupUnitAll.total_min_score;
    this.total_max_score = sumupUnitAll.total_max_score;
    this.man_examinee_count = sumupUnitAll.man_examinee_count;
    this.man_avg_score = sumupUnitAll.man_avg_score.toFixed(1);
    this.man_score_rate = sumupUnitAll.man_score_rate.toFixed(1);
    this.man_min_score = sumupUnitAll.man_min_score;
    this.man_max_score = sumupUnitAll.man_max_score;
    this.woman_examinee_count = sumupUnitAll.woman_examinee_count;
    this.woman_avg_score = sumupUnitAll.woman_avg_score.toFixed(1);
    this.woman_score_rate = sumupUnitAll.woman_score_rate.toFixed(1);
    this.woman_min_score = sumupUnitAll.woman_min_score;
    this.woman_max_score = sumupUnitAll.woman_max_score;
  }
}

export class Assessment {
  id: number
  sumup_unit_id: number
  is_gender_separate: boolean = false
  name: string
  sort_no: string
  score_type: number = 1
  result_published: boolean = true
  assessment_scores: AssessmentScore[] = []

  constructor(base_assessments: BaseAssessment[], assessment: any = null, assessment_scores: any[] = null){

    if(assessment){
      this.id = assessment.id;
      this.sumup_unit_id = assessment.sumup_unit_id;
      this.is_gender_separate = assessment.is_gender_separate;
      this.name = assessment.name;
      this.sort_no = assessment.sort_no;
      this.score_type = assessment.score_type;
      this.result_published = assessment.result_published;
      const target_assessment_scores = assessment_scores.filter((x: any) => x.assessment_id == this.id).sort((a: any, b: any) => a.sort_no - b.sort_no);
      
      this.assessment_scores = target_assessment_scores.map((x: any) => {
        const base_assessment = base_assessments.filter((y => y.id == x.base_assessment_id))[0];
        return new AssessmentScore(base_assessment, x);
      });
    }else{
      base_assessments.forEach(x => {
        this.assessment_scores.push(new AssessmentScore(x));
      });
    }
  }
}

export class AssessmentScore {
  id: number
  assessment_id: number
  base_assessment_id: number
  name: string
  sort_no: number
  total_score: string
  man_score: string
  woman_score: string
  comment: string

  constructor(base_assessment: BaseAssessment, assessment_score: any = null){
    if(assessment_score){
      this.id = assessment_score.id;
      this.base_assessment_id = assessment_score.base_assessment_id;
      this.assessment_id = assessment_score.assessment_id;
      this.sort_no = assessment_score.sort_no;
      this.total_score = assessment_score.total_score;
      this.man_score = assessment_score.man_score;
      this.woman_score = assessment_score.woman_score;
      this.comment = assessment_score.comment;
    }

    this.base_assessment_id = base_assessment.id;
    this.name = base_assessment.name;
    this.sort_no = base_assessment.sort_no;
  }
}
export class SearchCondtion {
  student_name: string = ""
  student_no_character: string = ""
}

export class AssessmentExaminee {
  assessment_id: number
  assessment_score_id: number
  practice_examinee_id: number

  constructor(assessment_examinee: any){
    this.assessment_id = assessment_examinee.assessment_id;
    this.assessment_score_id = assessment_examinee.assessment_score_id;
    this.practice_examinee_id = assessment_examinee.practice_examinee_id;
  }
}

export class BaseAssessment {
  id: number
  name: string
  sort_no: number

  constructor(x: any){
    this.id = x.id;
    this.name = x.name;
    this.sort_no = x.sort_no;
  }
}